export default __webpack_public_path__ + "static/media/sam-and-karen-tent.35ce597a.jpeg";